import Wrapper from '../../../components/wrapper';
import Container from '../../../containers';
import { TyTableTitle } from '@tymbe/ty-components/table';
import { TyNavTabs, TyNavLink } from '@tymbe/ty-components/navigation';
import { Outlet } from 'react-router-dom';
import { Form } from 'informed';
import { TySearchBox } from '@tymbe/ty-components/inputs';
import { useQuery } from 'react-query';
import feathersClient from '../../../apiClient';
import { AbsenceState } from '@tymbe/schema/enums';
import { PaginatedTotalIndicator } from '../../../components/BadgePills/PaginatedTotalIndicator';
import { processingAbsencesQueryId } from './ProcessingAbsences.tab';

const processingAmountId = 'admin/processingAmount';

const AdminAdministrationAbsencePage = () => {
  const pageTitle = 'Absence';

  const { data: processingAmount } = useQuery(
    [processingAbsencesQueryId, processingAmountId],
    () =>
      feathersClient.service('application-excuse').find({
        query: {
          'application_excuse.state': AbsenceState.PROCESSING,
          $joinRelation: 'application(withDeleted).shift',
          $limit: 0,
        },
      })
  );

  return (
    <Wrapper padding="0px" margin="0px">
      <Container
        iconcolor="#B3CA1F"
        background="#fff"
        elevate
        contentstyle={{
          paddingLeft: '190px',
          paddingTop: '24px',
          paddingRight: '24px',
          paddingBottom: '24px',
        }}
        desktopHeader
        sidebar
        sidebarExtra
      >
        <TyTableTitle className="flex justify-between">
          {pageTitle}
          <Form>
            <TySearchBox name="search" placeholder="Hledej dle jména nebo ID" />
          </Form>
        </TyTableTitle>
        <TyNavTabs>
          <TyNavLink key="processing" to={{ pathname: 'processing' }}>
            Omluvenky
            <PaginatedTotalIndicator data={processingAmount} />
          </TyNavLink>
          <TyNavLink
            key="requestedClarifications"
            to={{
              pathname: 'requestedClarifications',
              // eslint-disable-next-line no-restricted-globals
              search: location.search,
            }}
          >
            Žádosti o upřesnení
          </TyNavLink>
          <TyNavLink
            key="unexcusedAbsences"
            to={{ pathname: 'unexcusedAbsences' }}
          >
            Neomluvené absence
          </TyNavLink>
          <TyNavLink key="canceledLate" to={{ pathname: 'canceledLate' }}>
            Nahlášené absence
          </TyNavLink>
          <TyNavLink key="resolved" to={{ pathname: 'resolved' }}>
            Vyřízené omluvenky
          </TyNavLink>
        </TyNavTabs>
        <Outlet />
      </Container>
    </Wrapper>
  );
};

export default AdminAdministrationAbsencePage;
